export function stripCapabilityWord(capability) {
  return capability && typeof capability === 'string' ? capability.replace('capability:', '') : '';
}

export default function getCapabilitiesText(capabilities) {
  if (!capabilities || capabilities.length === 0) {
    return '';
  }

  if (capabilities.length === 1) {
    return `This requires an app with the capability ${stripCapabilityWord(capabilities[0])}.`;
  }

  if (capabilities.length === 2) {
    return `This requires an app with the capabilities ${stripCapabilityWord(
      capabilities[0],
    )} and ${stripCapabilityWord(capabilities[1])}.`;
  }

  return capabilities.reduce((pre, current, index) => {
    if (index === capabilities.length - 1) {
      return `${pre}and ${stripCapabilityWord(current)}.`;
    } else {
      return `${pre}${stripCapabilityWord(current)}, `;
    }
  }, 'This requires an app with the capabilities ');
}
